import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/productOutline.svg';

export const IconProductOutline = createIconComponent(Icon);
